<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ data_local.EventAdminId > 0 ? "Update" : "Create" }} Admin</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :key="$vs.rtl">
      <div class="p-6">
        <!-- NAME -->
        <vs-input
          label="First Name"
          v-model="data_local.FirstName"
          class="mt-5 w-full"
          name="FirstName"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('FirstName')"
        >{{ errors.first('FirstName') }}</span>

        <!-- NAME -->
        <vs-input
          label="Last Name"
          v-model="data_local.LastName"
          class="mt-5 w-full"
          name="LastName"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('LastName')"
        >{{ errors.first('LastName') }}</span>

        <!-- Company -->
        <vs-input
          label="Organization"
          v-model="data_local.Company"
          class="mt-5 w-full"
          name="Company"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Company')"
        >{{ errors.first('Company') }}</span>

        <!-- Email -->
        <vs-input
          label="Email"
          v-model="data_local.Email"
          class="mt-5 w-full"
          name="Email"
          :disabled="data_local.EventAdminId"
          v-validate="'required|email'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>

        <!-- Password -->
        <div v-if="data_local.Password">
          <vs-input
            label="Password"
            v-model="data_local.Password"
            class="mt-5 w-full"
            name="Password"
            v-validate="'required|min:4'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Password')"
          >{{ errors.first('Password') }}</span>
        </div>
        <div class="pt-5" v-if="data_local.EventAdminId > 0">
          <vs-radio disabled v-model="data_local.adminType" vs-value="EventAdmin" vs-name="navbar-type-sticky" class="mr-3">Event Admin</vs-radio>
          <vs-radio disabled v-model="data_local.adminType" vs-value="AnalyticsAdmin" vs-name="navbar-type-floating">Analytics Admin</vs-radio>
        </div>
        <div class="pt-5" v-else>
          <vs-radio  v-model="data_local.adminType" vs-value="EventAdmin" vs-name="navbar-type-sticky" class="mr-3">Event Admin</vs-radio>
          <vs-radio  v-model="data_local.adminType" vs-value="AnalyticsAdmin" vs-name="navbar-type-floating">Analytics Admin</vs-radio>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: this.data,
    };
  },
  watch: {
    isSidebarActive(val) {
      this.data_local = this.data;
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.data_local.EventAdminId > 0) {
            this.$vs.loading();
            this.$store
              .dispatch("eventManagement/updateEventAdmin", {
                data: this.data_local,
              })
              .then((res) => {
                if(res.status == 200)
                {
                  this.$vs.notify({
                    position: "top-center",
                    color: "success",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                if(res.status == 500)
                {
                  this.$vs.notify({
                    position: "top-center",
                    color: "warning",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                this.$vs.loading.close();
                //this.$router.push({ name: "eventadmins" });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.$vs.loading();
            this.$store
              .dispatch("eventManagement/addEventAdmin", {
                data: this.data_local,
              })
              .then((res) => {
                if(res.status == 200)
                {
                  this.$vs.notify({
                    position: "top-center",
                    color: "success",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                if(res.status == 500)
                {
                  this.$vs.notify({
                    position: "top-center",
                    color: "warning",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                this.$vs.loading.close();
                //this.$router.push({ name: "eventadmins" });
              })
              .catch((err) => {
                console.log(err);
              });
          }

          this.$vs.loading.close();
          this.$emit("closeSidebar");

          //this.initValues()
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
